import { Dispatch, SetStateAction, useState } from 'react';
import { SearchState } from 'src/hooks/meilisearch/types/search-state';

type ReturnType = [SearchState, Dispatch<SetStateAction<SearchState>>];

interface InitialValues {
  q?: string;
  filter?: (string | string[])[];
  sort?: string[];
}

export const useSearchState = (initialValues?: InitialValues): ReturnType => {
  const [searchState, setSearchState] = useState<SearchState>({
    q: initialValues?.q ?? '',
    filter: initialValues?.filter ?? [],
    sort: initialValues?.sort ?? [],
  });

  return [searchState, setSearchState];
};
